"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveUsersFormComponent = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const ChartShowButtonComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/ChartShowButtonComponent");
const ActiveUsersAggregationComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/activeUsers/state/data/form/ActiveUsersAggregationComponent");
const PeriodDaysComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/common/PeriodDaysComponent");
const ActiveUsersPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/activeUsers/ActiveUsersPageDataProvider");
const ActiveUsersPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/activeUsers/ActiveUsersPageModelProvider");
const ActiveUsersFormComponent = () => {
    const pageDataContext = (0, ActiveUsersPageDataProvider_1.useActiveUsersPageDataContext)();
    const pageModelContext = (0, ActiveUsersPageModelProvider_1.useActiveUsersPageModelContext)();
    const jsonModel = pageModelContext.pageModelStateFns.getFormJSONModel();
    const last = jsonModel.getPeriodDaysJSONModel().getLast();
    const aggregation = jsonModel.getAggregationJSONModel().getAggregation();
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.Row, { gutter: 12 },
            React.createElement(antd_1.Col, null,
                React.createElement(PeriodDaysComponent_1.PeriodDaysComponent, { value: last, onChange: pageModelContext.pageModelStateFns.onPeriodChanged })),
            React.createElement(antd_1.Col, null,
                React.createElement(ActiveUsersAggregationComponent_1.ActiveUsersAggregationComponent, { value: aggregation, onChange: pageModelContext.pageModelStateFns.onAggregationChanged }))),
        React.createElement(antd_1.Row, { className: "drawButtonRow" },
            React.createElement(antd_1.Col, { span: 24 },
                React.createElement(ChartShowButtonComponent_1.ChartShowButtonComponent, { inProgress: pageDataContext.state.status.inProgress, onClick: pageModelContext.pageModelStateFns.show, disabled: false }))));
};
exports.ActiveUsersFormComponent = ActiveUsersFormComponent;
